import React from "react";

export function EllipsisTextOverflow(props: { text: string }) {
  const { text } = props;
  const [width, setWidth] = React.useState(100);
  const textRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    // The div ref is always attached before useEffect runs (refs populate during
    // commit, prior to effects), so the null branch is an unreachable teardown guard.
    /* v8 ignore next */
    if (textRef.current) {
      setWidth(textRef.current.offsetWidth);
    }
  }, [text]);

  return (
    <div ref={textRef}>
      <div
        className="whitespace-nowrap overflow-hidden text-ellipsis"
        style={{ width }}
        title={text}
      >
        {text}
      </div>
    </div>
  );
}
